export default "__VITE_PUBLIC_ASSET__469f122a__"